// extracted by mini-css-extract-plugin
module.exports = {"author":"b6_fl","wrapper":"b6_c0","fontImage":"b6_gQ","container":"b6_x"};